import Vuex from "vuex";
import axios from "axios";

const agendamentosStore = new Vuex.Store({
  state: {
    loadingUser: false,
    loadingSelectOptions: false,
    loadingTecnicos: false,
    loadingAgenda: false,
    loadingAgendaAtiva: false,
    page: 0,
    perPage: 10,
    usuarios: [],
    usuario: null,
    local_atendimento: null,
    is_valid_to_next: false,
    pessoa_cadastrada: null,
    atendimento: null,
    atendimentoAgendaAtiva: null,
    tecnico: null,
    expedienteAgenda: null,
    expedienteAgendaAtiva: null,
    agendamento: null,
    formas_acesso: [],
    tipos: [],
    locais_atendimento: [],
    servicos: [],
    unidades: [],
    unidades_internas: [],
    outrasUnidades: [],
    denuncias: [],
    motivos_reagendamento: [],
    tipos_contato: [],
    niveis: [],
    tecnicos: [],
    agenda: {},
    agendaAtiva: {},
    tipo_compromisso: [],
    agenda_status: [],
  },

  mutations: {
    SET_LOADING_USER(state, status) {
      state.loadingUser = status;
    },
    SET_IS_VALID_TO_NEXT(state, is_valid_to_next) {
      state.is_valid_to_next = is_valid_to_next;
    },
    SET_AGENDA(state, agenda) {
      state.agenda = agenda;
    },
    SET_AGENDA_ATIVA(state, agendaAtiva) {
      state.agendaAtiva = agendaAtiva;
    },
    SET_TECNICO(state, tecnico) {
      state.tecnico = tecnico;
    },
    SET_PESSOA_CADASTRADA(state, pessoa_cadastrada) {
      state.pessoa_cadastrada = pessoa_cadastrada;
    },
    SET_USUARIOS(state, usuarios) {
      state.usuarios = usuarios;
    },
    SET_MOTIVOS_REAGENDAMENTO(state, motivos_reagendamento) {
      state.motivos_reagendamento = motivos_reagendamento;
    },
    SET_USUARIO(state, usuario) {
      state.usuario = usuario;
    },
    SET_DENUNCIAS(state, denuncias) {
      state.denuncias = denuncias;
    },
    SET_TECNICOS(state, tecnicos) {
      state.tecnicos = tecnicos;
    },
    SET_AGENDAMENTO(state, agendamento) {
      state.agendamento = agendamento;
    },
    SET_LOADING_TECNICOS(state, loadingTecnicos) {
      state.loadingTecnicos = loadingTecnicos;
    },
    SET_NIVEIS(state, niveis) {
      state.niveis = niveis;
    },
    SET_LOCAIS_ATENDIMENTO(state, locais_atendimento) {
      state.locais_atendimento = locais_atendimento;
    },
    SET_LOADING_AGENDA(state, loadingAgenda) {
      state.loadingAgenda = loadingAgenda;
    },
    SET_LOADING_AGENDA_ATIVA(state, loadingAgendaAtiva) {
      state.loadingAgendaAtiva = loadingAgendaAtiva;
    },
    SET_UNIDADES_INTERNAS(state, unidades_internas) {
      state.unidades_internas = unidades_internas;
    },
    SET_LOCAL_ATENDIMENTO(state, local_atendimento) {
      state.local_atendimento = local_atendimento;
    },
    SET_LOADING_SELECT_OPTIONS(state, loadingSelectOptions) {
      state.loadingSelectOptions = loadingSelectOptions;
    },
    SET_FORMAS_ACESSO(state, formas_acesso) {
      state.formas_acesso = formas_acesso;
    },
    SET_EXPEDIENTE_AGENDA(state, expedienteAgenda) {
      state.expedienteAgenda = expedienteAgenda;
    },
    SET_EXPEDIENTE_AGENDA_ATIVA(state, expedienteAgendaAtiva) {
      state.expedienteAgendaAtiva = expedienteAgendaAtiva;
    },
    SET_TIPOS_CONTATOS(state, tipos_contato) {
      state.tipos_contato = tipos_contato;
    },
    SET_OUTRAS_UNIDADES(state, outrasUnidades) {
      state.outrasUnidades = outrasUnidades;
    },
    SET_TIPOS(state, tipos) {
      state.tipos = tipos;
    },
    SET_SERVICOS(state, servicos) {
      state.servicos = servicos;
    },
    SET_AGENDA_STATUS(state, agenda_status) {
      state.agenda_status = agenda_status;
    },
    SET_UNIDADES(state, unidades) {
      state.unidades = unidades;
    },
    SET_ATENDIMENTO(state, atendimento) {
      state.atendimento = atendimento;
    },
    SET_ATENDIMENTO_AGENDA_ATIVA(state, atendimentoAgendaAtiva) {
      state.atendimentoAgendaAtiva = atendimentoAgendaAtiva;
    },
    SET_TIPO_COMPROMISSO(state, tipo_compromisso) {
      state.tipo_compromisso = tipo_compromisso;
    },
  },

  actions: {
    async getUser({ commit, state }, { search, situacao_rua }) {
      commit("SET_LOADING_USER", true);

      try {
        const response = await axios.get(`api/dashboard/agenda/pesquisa/usuarios?search=${search}&situacao_rua=${situacao_rua}`);

        commit("SET_USUARIOS", response.data);
      } catch (error) {
        return error;
      } finally {
        commit("SET_LOADING_USER", false);
      }
    },

    async saveUser({ commit }, { item }) {
      try {
        const response = await axios.post(`api/dashboard/familia/store`, item);

        commit("SET_PESSOA_CADASTRADA", response.data.data);

        commit("SET_IS_VALID_TO_NEXT", true);

        return response;
      } catch (error) {
        commit("SET_IS_VALID_TO_NEXT", false);
        throw error;
      }
    },

    async saveAtendimento({ commit }, { item }) {
      try {
        const response = await axios.post(`api/dashboard/atendimentos`, item);

        commit("SET_ATENDIMENTO", response.data.data);

        commit("SET_IS_VALID_TO_NEXT", true);

        return response;
      } catch (error) {
        commit("SET_IS_VALID_TO_NEXT", false);
        throw error;
      }
    },

    async getSelectOptions({ commit }) {
      commit("SET_LOADING_SELECT_OPTIONS", true);

      try {
        const response =
          await axios.get(`api/dashboard/atendimento/get/imformacao/campo?scope[tipos]=agenda-tipos&scope[servicos]=agenda-servicos`);

        commit("SET_DENUNCIAS", response.data.denuncias);
        commit("SET_FORMAS_ACESSO", response.data.formas_acesso);
        commit("SET_TIPOS", response.data.tipos);
        commit("SET_SERVICOS", response.data.servicos);
        commit("SET_UNIDADES", response.data.unidades);
        commit("SET_TIPOS_CONTATOS", response.data.tipos_contato);
        commit("SET_LOCAIS_ATENDIMENTO", response.data.locais_atendimento);
        commit("SET_UNIDADES_INTERNAS", response.data.unidades_internas);
        commit("SET_NIVEIS", response.data.niveis);
        commit("SET_TIPO_COMPROMISSO", response.data.tipo_compromisso);
        commit("SET_AGENDA_STATUS", response.data.agenda_status);
        commit("SET_MOTIVOS_REAGENDAMENTO", response.data.motivos_reagendamento);

        return response;
      } catch (error) {
        return error;
      } finally {
        commit("SET_LOADING_SELECT_OPTIONS", false);
      }
    },

    async getTecnicos({ commit }, { funcao_unidade, unidade_id }) {
      commit("SET_LOADING_TECNICOS", true);

      try {
        const response = await axios.get(`api/dashboard/tecnicos/by-unidade?funcao_unidade=${funcao_unidade}&unidade_id=${unidade_id}`);

        commit("SET_TECNICOS", response.data.data);

        return response;
      } catch (error) {
        return error;
      } finally {
        commit("SET_LOADING_TECNICOS", false);
      }
    },

    async getAgenda({ commit }, { tecnico_id, dia, loading_mutations, model_mutations }) {
      commit(loading_mutations, true);

      try {
        const response = await axios.get(`api/dashboard/tecnico/${tecnico_id}/agenda?dia=${dia}`);

        commit(model_mutations, response.data?.data);

        return response;
      } catch (error) {
        return error;
      } finally {
        commit(loading_mutations, false);
      }
    },

    async getAgendamento({ commit }, { agenda_atendimento_id }) {
      try {
        const response = await axios.get(`api/dashboard/agendamento/${agenda_atendimento_id}`);

        commit("SET_AGENDAMENTO", response.data.data);
        return response;
      } catch (error) {
        return error;
      }
    },

    async getAtendimento({ commit }, { atendimento_id }) {
      try {
        const response = await axios.get(`api/dashboard/atendimentos-agenda/${atendimento_id}`);

        commit("SET_IS_VALID_TO_NEXT", true);

        return response;
      } catch (error) {
        commit("SET_IS_VALID_TO_NEXT", false);
        return error;
      }
    },

    async putAtendimento({ commit }, { atendimento, atendimento_id, model_mutations = "SET_ATENDIMENTO" }) {
      try {
        const response = await axios.put(`api/dashboard/atendimentos-agenda/${atendimento_id}`, atendimento);

        commit(model_mutations, response.data.data);

        commit("SET_IS_VALID_TO_NEXT", true);

        return response;
      } catch (error) {
        commit("SET_IS_VALID_TO_NEXT", false);
        return error;
      }
    },

    async getExpediente({ commit }, { unidade_id, dia, model_mutations }) {
      try {
        const response = await axios.get(`api/dashboard/unidade/expediente?unidade_id=${unidade_id}&dia=${dia}`);
        commit(model_mutations, response.data.data);
        return response;
      } catch (error) {
        commit(model_mutations, null);
        return error;
      }
    },

    async cancelar({ commit }, { agendamento_id }) {
      try {
        return await axios.delete(`api/dashboard/agendamento/${agendamento_id}/cancelar`);
      } catch (error) {
        return error;
      }
    },

    async saveAgendamento({ commit }, { item }) {
      try {
        return await axios.post(`api/dashboard/agenda`, item);
      } catch (error) {
        commit("SET_IS_VALID_TO_NEXT", false);
        throw error;
      }
    }
  }
});

export default agendamentosStore;
